import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_WHITE } from "../lib/api";
import { useScrolled } from "../hooks/useScrolled";
import DesktopNav from "./nav/DesktopNav";
import MobileMenu from "./nav/MobileMenu";

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const scrolled = useScrolled();
    const location = useLocation();

    useEffect(() => {
        setOpen(false);
    }, [location.pathname, setOpen]);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-[#050814]/85 backdrop-blur-xl border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="xpo-container flex items-center justify-between h-20">
                <Link
                    to="/"
                    data-testid="nav-logo-link"
                    className="flex items-center"
                >
                    <img
                        src={LOGO_WHITE}
                        alt="XPO Markets"
                        className="h-12 w-auto object-contain"
                    />
                </Link>

                <DesktopNav />

                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden text-white p-2"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && <MobileMenu />}
        </header>
    );
}
